// eslint-disable filename-rules/match
require('@webapp/common/lib/sentry').default('account');
require('@webapp/common/lib/wdyr');

import { createRoot } from 'react-dom/client';

import './index.css?CSSModulesDisable';
import '@webapp/common/assets/styles/globals.css?CSSModulesDisable';
import '@webapp/common/lib/date';
import '@webapp/common/assets/styles/fonts.css';

import { initYaMetrika } from '@webapp/common/lib/metrics';
import { LocalStorage } from '@webapp/common/lib/storage';

import { App } from '@webapp/account/src/app';

import { WithGlobalStore } from '@webapp/common/components/with-global-store';

import { installChunkLoadReload } from '@webapp/common/lib/chunk-error';

LocalStorage.clearExpired();
installChunkLoadReload();
initYaMetrika();

const root = createRoot(document.getElementById('app'));
const TMP = () => {
    return (
        <>
            <App />
        </>
    );
};
root.render(<WithGlobalStore element={<TMP />} />);
